import { Cliente } from "./cliente";

export class Telefone {
  ddd: number;
  numero: number;
  ramal: number;
  clienteId: number;
  cliente: Cliente
}
